import { useWorkbookDifficultyStatistics } from '~/@common/hooks/useWorksheetParentReport'

import { DifficultyStatisticsCard } from './DifficultyStatisticsCard'

type Props = {
  progressId?: number | null
}

export const WorkbookDifficultyStatistics = ({ progressId }: Props) => {
  const { data } = useWorkbookDifficultyStatistics(progressId)
  return <DifficultyStatisticsCard data={data ?? []} />
}
